<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'companiesCrud'"
          crud-name="Empresas"
          new-text="Nova Empresa"
          :table="table"
          :columns="columns"
          :options="options"
          :end-point="endPoint"
          :enable-add="true"
          :enable-edit="true"
          :enable-delete="true"
          :enable-view="false"
          :data-form="dataForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      table: 'companiesTable',
      showMessageImport: false,
      companiesCrud: {},
      pages: [],
      url: '',
      columns: ['id', 'company_name', 'cnpj', 'status', 'actions'],
      tableData: [
        'id',
        'company_name',
        'cnpj',
        'email',
        'cep',
        'street',
        'number',
        'complement',
        'neighborhood',
        'city',
        'state',
        'country',
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ['company_name', 'cnpj', 'status'],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: 'ID',
          company_name: 'Nome da Empresa',
          cnpj: 'CNPJ',
          status: 'Status',
          actions: 'Ações',
        },
        sortable: [],
        sortIcon: {
          base: 'fas',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        texts: {
          filterBy: 'Filtrar',
          defaultOption: 'Selecione',
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: 'Ativo',
            },
            {
              id: 0,
              text: 'Inativo',
            },
          ],
        },
        templates: {
          status(h, row, index) {
            return row.status == 1
              ? 'Ativo'
              : row.status == 0
                ? 'Inativo'
                : 'Inativo'
          },
        },
        requestFunction(data) {
          const requestData = {}

          const query = this.$parent.$parent.$parent.query(data.query)
          requestData.params = data

          requestData.params.query = ''
          requestData.params.with = ['']

          return axios.get(`${this.url}?${query}`, requestData).catch(
            e => {
              this.dispatch('error', e)
            },
          )
        },
      },
      endPoint: 'companies/',
      dataForm: {},
    }
  },
  methods: {
    makeFormData() {
      const self = this
      const fd = new FormData()

      const fileImport = document.getElementById('fileImport')

      fd.append('fileImport', fileImport.files[0] ? fileImport.files[0] : '')

      return fd
    },
    importFile() {
      const self = this
      const api = `${self.$store.state.api}import-users`

      const fd = self.makeFormData()

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Informações guardadas com sucesso',
            'success',
          )
          self.showMessageImport = true
          self.$refs.usersCrud.$refs.table.refresh()
        })
        .catch(error => {
          self.$message(
            'Ops',
            'Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.',
            'error',
          )
        })
    },
    query(query) {
      const columns = {
        id: 'id',
        company_name: 'company_name',
        cnpj: 'cnpj',
        status: 'status',
      }
      let filters = ''
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`
      })
      return filters
    },
    openInput() {
      document.getElementById('fileImport').click()
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
